import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import MetaTags from 'components/Common/MetaTags';
import Breadcrumbs from 'UI/components/Breadcrumbs';
import { PAGES } from 'utils/constants';
import { getDocumentFields } from 'utils/helper';
import SectionSelector from 'UI/components/SectionSelector';
import FullScreenEstimation from 'components/Common/FullScreenEstimation';
import usePersonProps from './utils/usePersonProps';
import styles from './styles.module.scss';

const PersonBlog = dynamic(() => import('UI/sections/Blog/PersonBlog'));

const PersonPageContainer = (props) => {
  const {
    type,
    currentPage,
    articlesNumberPerPage,
    pageData: contentModules,
    articlesData,
    additionalMicrodata,
    breadcrumbs,
    personMetadata,
    introSection,
  } = usePersonProps(props);

  const [isFullscreenEstimation, setIsFullscreenEstimation] = useState(false);

  const openFullscreenEstimation = () => setIsFullscreenEstimation(true);
  const closeFullscreenEstimation = () => setIsFullscreenEstimation(false);

  return (
    <>
      <MetaTags
        page={PAGES.person}
        pageMetadata={personMetadata}
        breadcrumbs={breadcrumbs}
        microData={additionalMicrodata}
      />
      <main className={styles.pageMain}>
        <div className={styles.container}>
          <Breadcrumbs
            breadcrumbs={breadcrumbs}
            dark
          />
        </div>
        {contentModules?.map((module, i) => {
          const { type: sectionType, view } = getDocumentFields(module);

          return (
            <SectionSelector
              key={`section/${i}`}
              data={module}
              type={type}
              introSection={introSection}
              handleOnCTAClick={openFullscreenEstimation}
            />
          );
        })}

        <PersonBlog
          title="Latest blog posts"
          articlesNumberPerPage={articlesNumberPerPage}
          currentPage={currentPage}
          {...articlesData}
        />
        {/* <FeedbackSection
          budget
          type="person"
          section={{
            fields: {
              budget: true,
              title: 'Do you want to create a top-notch software solution? Yellow is here to help!',
              buttonTitle: 'Request a quote',
            },
          }}
        /> */}
      </main>
      <FullScreenEstimation
        isFullscreenEstimation={isFullscreenEstimation}
        closeFullscreenEstimation={closeFullscreenEstimation}
      />
    </>
  );
};

export default PersonPageContainer;
